"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var clone = require('clone');

var tv4 = require('tv4');

var SubstanceComponent = /*#__PURE__*/function () {
  function SubstanceComponent(opt) {
    _classCallCheck(this, SubstanceComponent);

    this.cas = null;
    this.name = null;
    this.min = null;
    this.max = null;

    if (opt) {
      this.fillObject(clone(opt));
    }
  }

  _createClass(SubstanceComponent, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this.cas = opt.cas || null;
      this.name = opt.name || null;
      this.min = parseFloat(opt.min) || null;
      this.max = parseFloat(opt.max) || null;
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, SubstanceComponent.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'substance-component.schema.json',
        type: 'object',
        properties: {
          cas: {
            type: ['string', 'null']
          },
          name: {
            type: ['string', 'null']
          },
          min: {
            type: ['number', 'null']
          },
          max: {
            type: ['number', 'null']
          }
        },
        required: Object.keys(this)
      };
    }
  }]);

  return SubstanceComponent;
}();

module.exports = SubstanceComponent;